"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { cn } from '../../helpers/cn.mjs';
import { forwardRef } from 'react';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';

const PopoverContainer = forwardRef(
  ({ children, className, ...props }, ref) => {
    const styles = dropdownRecipe();
    return /* @__PURE__ */ jsx("div", { ref, className: cn(className, styles["popover-container"]), ...props, children });
  }
);

export { PopoverContainer };
